<template>
  <div class="layout">
    <aside class="sidebar" :class="{ 'is-collapsed': sidebarCollapsed }">
      <div class="logo">
        <span class="logo-text">{{ sidebarCollapsed ? '体测' : '体测管理系统' }}</span>
      </div>
      <el-menu
        router
        :default-active="active"
        :collapse="sidebarCollapsed"
        :collapse-transition="true"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/student">
          <i class="el-icon-user"></i>
          <span slot="title">学员管理</span>
        </el-menu-item>
        <el-menu-item index="/radar-dimension">
          <i class="el-icon-s-operation"></i>
          <span slot="title">列表维护</span>
        </el-menu-item>
        <el-menu-item index="/score-range">
          <i class="el-icon-document"></i>
          <span slot="title">成绩区间</span>
        </el-menu-item>
        <el-menu-item index="/age-range-fields">
          <i class="el-icon-view"></i>
          <span slot="title">分段栏位查询</span>
        </el-menu-item>
        <el-menu-item index="/height-standard">
          <i class="el-icon-s-data"></i>
          <span slot="title">身高标准</span>
        </el-menu-item>
      </el-menu>
    </aside>
    <div class="main">
      <header class="navbar">
        <div class="navbar-left">
          <div
            class="hamburger"
            role="button"
            tabindex="0"
            title="展开/收起菜单"
            @click="toggleSidebar"
            @keyup.enter="toggleSidebar"
          >
            <i :class="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </div>
          <span class="title">{{ currentTitle }}</span>
        </div>
        <el-button type="text" @click="logout">退出</el-button>
      </header>
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data() {
    return {
      sidebarCollapsed: false
    }
  },
  computed: {
    active() {
      return this.$route.path
    },
    currentTitle() {
      return (this.$route.meta && this.$route.meta.title) || ''
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    logout() {
      sessionStorage.removeItem('Admin-Token')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.layout {
  display: flex;
  height: 100%;
}
.sidebar {
  width: 210px;
  flex-shrink: 0;
  background: #304156;
  color: #fff;
  display: flex;
  flex-direction: column;
  transition: width 0.28s ease;
  overflow: hidden;
}
.sidebar.is-collapsed {
  width: 64px;
}
.logo {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  background: #2b3a4b;
  flex-shrink: 0;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.logo-text {
  display: inline-block;
  max-width: 100%;
}
.sidebar >>> .el-menu {
  border-right: none;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.sidebar >>> .el-menu::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.navbar {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e6e6e6;
  background: #fff;
}
.navbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.hamburger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  color: #606266;
  font-size: 18px;
  flex-shrink: 0;
  transition: background 0.2s, color 0.2s;
}
.hamburger:hover {
  background: #f0f2f5;
  color: #409eff;
}
.title {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content {
  flex: 1;
  padding: 16px;
  background: #f0f2f5;
  overflow: auto;
}
</style>
